"use strict";

var _taggedTemplateLiteral = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex: ", ";\n  flex-direction: ", ";\n  align-items: ", ";\n  justify-content: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var styled_components_1 = __importDefault(require("styled-components"));

var Flex = styled_components_1.default.div(_templateObject(), function (_ref) {
  var auto = _ref.auto;
  return auto ? "1 1 auto" : "initial";
}, function (_ref2) {
  var column = _ref2.column;
  return column ? "column" : "row";
}, function (_ref3) {
  var align = _ref3.align;
  return align;
}, function (_ref4) {
  var justify = _ref4.justify;
  return justify;
});
exports.default = Flex;